import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ContentCopy as CopyIcon } from '@mui/icons-material';

import { HeadOfficeAddress } from '../types/company.types';
import { commonButtonStyles, PaperBoxStyles } from '../../../components/styles/common-style';

import AddressSection from '@/features/apps/components/address-section';

interface HeadOfficeAddressSectionProps {
  headOfficeAddress: HeadOfficeAddress;
  originalHeadOfficeAddress?: HeadOfficeAddress;
  onUpdateAddressField: (field: keyof HeadOfficeAddress, value: string) => void;
  onCopyCurrentToHeadOffice: () => void;
  getFieldError: (fieldName: string) => string | undefined;
  isFieldValid: (fieldName: string) => boolean;
}

export const HeadOfficeAddressSection: React.FC<HeadOfficeAddressSectionProps> = ({
  headOfficeAddress,
  originalHeadOfficeAddress,
  onUpdateAddressField,
  onCopyCurrentToHeadOffice,
  getFieldError,
  isFieldValid,
}) => {
  // Provide default values if address is undefined
  const safeAddress = headOfficeAddress || {
    postalCode1: '',
    postalCode2: '',
    address1: '',
    address2: '',
    address3: '',
  };

  return (
    <PaperBoxStyles elevation={1} sx={{ mb: 3, paddingBottom: '32px' }} id='head-office-address'>
      <Typography
        variant='h5'
        sx={{
          mb: 3,
          color: '#1A1C20',
          fontSize: '22px',
          fontWeight: 600,
        }}
      >
        本社住所
      </Typography>

      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography
            variant='h6'
            sx={{
              color: '#1A1C20',
              fontSize: '16px',
              fontWeight: 500,
            }}
          >
            本社住所
          </Typography>
          <Button
            variant='outlined'
            size='small'
            startIcon={<CopyIcon />}
            onClick={onCopyCurrentToHeadOffice}
            sx={commonButtonStyles}
          >
            住所地からコピー
          </Button>
        </Box>

        {/* Postal Code */}
        <AddressSection
          safeAddress={safeAddress}
          originalSafeAddress={originalHeadOfficeAddress}
          onUpdateAddressField={(field, value) =>
            onUpdateAddressField(field as keyof HeadOfficeAddress, value)
          }
          getFieldError={getFieldError}
          isFieldValid={isFieldValid}
          addressType='headOfficeAddress'
        />
      </Box>
    </PaperBoxStyles>
  );
};
